module.exports = __webpack_public_path__ + "img/head_portrait2.f019f8d1.png";